module.exports = __webpack_public_path__ + "src/assets/img/s-settings.4aa28cf1.svg";